module.exports = __webpack_public_path__ + "static/img/logo.170a7d04.png";